import { GenericCrudPage } from '@/components/GenericCrudPage';
import { industriesConfig } from '@/pages/configs';

export default function IndustriesGenericPage() {
  return <GenericCrudPage config={industriesConfig} />;
}
